import React from "react";
import { Avatar, Typography } from "@material-ui/core";
import { groopTheme } from "../../styles/MaterialGroopTheme";
import { makeStyles } from "@material-ui/core/styles";

interface INumberedCircleComponentProps {
  size: number;
  number: number;
}

export const NumberedCircle = (
  props: INumberedCircleComponentProps,
): JSX.Element => {
  const useStyles = makeStyles((theme) => ({
    avatar: {
      backgroundColor: groopTheme.palette.common.white,
      border: `1px solid ${groopTheme.palette.secondary.main}`,
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  }));
  const classes = useStyles();

  return (
    <Avatar className={classes.avatar}>
      <Typography component="span" color="secondary" variant="h6">
        {props.number}
      </Typography>
    </Avatar>
  );
};
